import { NgStyle } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import videojs from 'video.js';

@Component({
    selector: 'topo-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
    imports: [NgStyle]
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('target', { static: true }) target: ElementRef<HTMLVideoElement>;
  @Input() visible: boolean;
  @Input() options: {
    fluid: boolean;
    aspectRatio: string;
    autoplay: boolean;
    sources: {
      src: string;
      type: string;
    }[];
  };

  @Input() width: string;
  @Input() height: string;
  @Output() videoLoaded = new EventEmitter<void>();
  player: videojs.Player;

  ngOnInit(): void {
    // instantiate Video.js
    if (!this.width) {
      this.width = '389px';
    }
    if (!this.height) {
      this.height = '275px';
    }

    const component = this;

    if (this.options?.sources) {
      let source = this.options.sources[0];

      if (source.src) {
        const linkMarkdownFormat = /^\[(?<name>.*)\]\((?<url>.*)\)$/gm;
        const match = linkMarkdownFormat.exec(source.src);
        let url = match?.groups?.url;

        if (!url) {
          url = source.src;
        } else {
          source.src = url;
        }
      }
    }

    this.player = videojs(this.target.nativeElement, this.options, function () {
      this.on('loadedmetadata', function () {
        component.videoLoaded.emit();
      });
    });
  }

  ngOnDestroy(): void {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }
}
